import { bffRetailMedia } from '~/middlewares/axios'

export type AudienceUploadResult = {
  key: string
  bucket: string
}

/**
 * Sobe o arquivo ao BFF (multipart) — o BFF sobe para o S3 em seguida, o navegador
 * nunca fala com o armazenamento diretamente.
 */
export const uploadAudience = async (
  file: File
): Promise<AudienceUploadResult> => {
  const form = new FormData()

  form.append('file', file)

  const { data } = await bffRetailMedia.post<AudienceUploadResult>(
    '/audience/upload',
    form
  )

  return data
}
